module.exports = __webpack_public_path__ + "static/media/checkExample2.231dea57.png";